import { render, staticRenderFns } from "./GeneralInputItem.vue?vue&type=template&id=a6c552e6"
import script from "./GeneralInputItem.vue?vue&type=script&lang=js"
export * from "./GeneralInputItem.vue?vue&type=script&lang=js"
import style0 from "./GeneralInputItem.vue?vue&type=style&index=0&id=a6c552e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports